<template>
  <div class="out-of-flow">
  <round-button
    :icon="icon"
    :flip-icon="flipIcon"
    class="out-of-flow-icon"
    ref="outOfFlowButton"
    v-on="$listeners"
    />
    <span
      class="r-text-bold cursor-pointer"
      @click="triggerOutOfFlowButton">{{ text }}</span>
  </div>
</template>

<script>
import RoundButton from '@/components/styled/RoundButton';

export default {
  name: 'OutOfFlowButton',
  components: { RoundButton },
  props: {
    icon: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    flipIcon: Boolean,
  },
  methods: {
    triggerOutOfFlowButton() {
      this.$refs.outOfFlowButton.$listeners.click();
    },
  },
};
</script>

<style scoped lang="scss">
.out-of-flow {
  margin-top: 16px;

  .out-of-flow-icon {
    margin-right: 15px;
  }
}

</style>
